import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ContainerLoadTypesService, ContainerLoadType } from '../../../../services/forwarding/container-load-types.service';

@Component({
  selector: 'app-container-load-types-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './container-load-types-modal.html',
  styleUrl: './container-load-types-modal.css'
})
export class ContainerLoadTypesModalComponent implements OnInit, OnDestroy {
  showModal = false;
  showAddModal = false;
  isEditMode = false;
  editingId: number | null = null;
  searchTerm = '';

  loadTypes: ContainerLoadType[] = [];
  filteredLoadTypes: ContainerLoadType[] = [];

  formData: Omit<ContainerLoadType, 'id' | 'createdAt'> = this.getEmptyFormData();

  private subscriptions = new Subscription();

  constructor(private containerLoadTypesService: ContainerLoadTypesService) {}

  ngOnInit(): void {
    // Subscribe to load types from service
    this.subscriptions.add(
      this.containerLoadTypesService.getLoadTypes().subscribe(types => {
        this.loadTypes = types;
        this.applyFilters();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  open(): void {
    this.showModal = true;
  }

  close(): void {
    this.showModal = false;
  }

  applyFilters(): void {
    if (!this.searchTerm) {
      this.filteredLoadTypes = this.loadTypes;
    } else {
      const term = this.searchTerm.toLowerCase();
      this.filteredLoadTypes = this.loadTypes.filter(lt =>
        lt.label.toLowerCase().includes(term) ||
        lt.code.toLowerCase().includes(term) ||
        lt.notes.toLowerCase().includes(term)
      );
    }
  }

  openAddModal(): void {
    this.isEditMode = false;
    this.editingId = null;
    this.formData = this.getEmptyFormData();
    this.showAddModal = true;
  }

  editLoadType(loadType: ContainerLoadType): void {
    this.isEditMode = true;
    this.editingId = loadType.id || null;
    this.formData = {
      label: loadType.label,
      code: loadType.code,
      category: loadType.category,
      notes: loadType.notes
    };
    this.showAddModal = true;
  }

  deleteLoadType(loadType: ContainerLoadType): void {
    if (confirm(`Are you sure you want to delete "${loadType.label}"?`)) {
      if (loadType.id) {
        this.containerLoadTypesService.deleteLoadType(loadType.id);
      }
    }
  }

  saveLoadType(): void {
    if (this.isEditMode && this.editingId) {
      this.containerLoadTypesService.updateLoadType(this.editingId, this.formData);
    } else {
      this.containerLoadTypesService.addLoadType(this.formData);
    }
    this.closeAddModal();
  }

  closeAddModal(): void {
    this.showAddModal = false;
    this.formData = this.getEmptyFormData();
  }

  formatDate(date: Date): string {
    return new Date(date).toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' });
  }

  private getEmptyFormData(): Omit<ContainerLoadType, 'id' | 'createdAt'> {
    return {
      label: '',
      code: '',
      category: 'SEA',
      notes: ''
    };
  }
}
